const formHelper = {
	el: {
		checkbox: document.querySelectorAll('.js-checkbox')
	},

	fxFormToJson(el) {
		const indexedArray = {}
		for (let i = 0; i < el.length; i++) {
			if (el[i].value) {
				if (['checkbox', 'radio'].indexOf(el[i].type) > -1 && el[i].checked || ['checkbox', 'radio', 'file', 'button'].indexOf(el[i].type) === -1)
					indexedArray[el[i].name] = el[i].value
			}
		}
		return indexedArray
	},

	fxInputEvents() {
		this.el.checkbox.forEach(el => el.addEventListener('change', e => e.currentTarget.value = e.currentTarget.checked ? 'true' : 'false'))
	},

	fxShowMessage(form, msg, status = 200) {
		const buttonSubmit = form.querySelector('.js-submit'),
			buttonClear = form.querySelector('.js-clear-file'),
			inputHiddenValue = form.querySelector('.upload-file__value'),
			inputFile = form.querySelector('[type="file"]'),
			fileName = form.querySelector('.upload-file__name'),
			messageContainer = form.nextElementSibling

		if (msg) {
			buttonSubmit.style.display = 'none'
			messageContainer.textContent = msg
			messageContainer.style.display = 'inherit'
		}

		setTimeout(() => {
			if (messageContainer) {
				messageContainer.textContent = ''
				messageContainer.style.display = 'none'
			}
			buttonSubmit.removeAttribute('disabled')
			buttonSubmit.style.display = 'inherit'
			status === 200 && form.reset()

			if (inputFile) {
				form.value = ''
				inputHiddenValue.value = ''
				fileName.textContent = ''
				buttonClear && setTimeout(() => buttonClear.style.display = 'none', 0)
			}
		}, 5000)
	},

	init() {
		this.fxInputEvents()
	}
}

formHelper.init()